var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571429,
    y: 0.571429,
    width: 34.8571,
    height: 22.8571,
    rx: 1.71429,
    fill: "white",
    stroke: "#E5E5EA",
    strokeWidth: 1.14286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9839 16.4599H13.5871L15.0862 8.05951H17.4829L15.9839 16.4599Z",
    fill: "#15195A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6722 8.26487C24.1995 8.0949 23.4497 7.90723 22.5225 7.90723C20.1556 7.90723 18.4889 9.05105 18.4786 10.6864C18.459 11.8929 19.672 12.5631 20.5792 12.9654C21.5065 13.3765 21.8217 13.6448 21.8217 14.0112C21.8123 14.574 21.0724 14.8334 20.3824 14.8334C19.4255 14.8334 18.9127 14.6996 18.1335 14.3865L17.8179 14.2523L17.4825 16.138C18.0447 16.3701 19.0804 16.5761 20.1556 16.5851C22.6705 16.5851 24.3077 15.459 24.3271 13.7163C24.3367 12.76 23.6962 12.0273 22.3153 11.4285C21.477 11.0441 20.9636 10.785 20.9636 10.3917C20.9735 10.0342 21.3978 9.66799 22.3441 9.66799C23.1233 9.65005 23.6958 9.81978 24.1295 9.98964L24.3463 10.0788L24.6722 8.26487V8.26487V8.26487Z",
    fill: "#15195A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9626 8.05951H30.8165L32.7501 16.4598H30.5309C30.5309 16.4598 30.3137 15.4946 30.2449 15.1997H27.1676C27.0786 15.423 26.6646 16.4598 26.6646 16.4598H24.1497L27.7098 8.7565C27.9565 8.21131 28.3908 8.05951 28.9626 8.05951ZM28.8149 11.1336C28.8149 11.1336 28.0554 13.0014 27.858 13.484H29.8502C29.7516 13.064 29.2977 11.0532 29.2977 11.0532L29.1302 10.3294C29.0597 10.5158 28.9577 10.772 28.8889 10.9449C28.8423 11.062 28.8109 11.1409 28.8149 11.1336Z",
    fill: "#15195A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20214 8.05951H7.05833C7.58102 8.07721 8.00514 8.22912 8.14316 8.76564L8.98113 12.6249C8.98125 12.6253 8.98137 12.6257 8.98149 12.626L9.23799 13.7878L11.5852 8.05952H14.1196L10.3523 16.451H7.81777L5.68152 9.15182C4.94444 8.76129 4.10322 8.44721 3.16269 8.22924L3.20214 8.05951Z",
    fill: "#15195A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f983cc759fd23b3d2bfe58f9a2f60f01.svg";
export { ForwardRef as ReactComponent };